import { render, staticRenderFns } from "./Suporte.vue?vue&type=template&id=1c7f00b5"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"
import style0 from "./Suporte.vue?vue&type=style&index=0&id=1c7f00b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports